"use strict";

// Runtime configuration from window.ENV (generated at container startup)
const runtimeConfig = (typeof window !== 'undefined' && window.ENV) || {};

const baseURL = runtimeConfig.REACT_APP_API_PATH ||
  process.env.REACT_APP_API_PATH || 
  process.env.REACT_APP_BASE_URL ||
  "http://localhost:3000";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.baseURL = baseURL; 
